import { render } from "./dialog-billing.vue?vue&type=template&id=532ff0e4&scoped=true"
import script from "./dialog-billing.vue?vue&type=script&lang=js"
export * from "./dialog-billing.vue?vue&type=script&lang=js"

import "./dialog-billing.vue?vue&type=style&index=0&id=532ff0e4&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532ff0e4"]])

export default __exports__